var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-wrap justify-center"},[_c('h3',{staticClass:"text-center",staticStyle:{"width":"100%"}},[_vm._v("Kalender")]),_c('Calendar',{attrs:{"small":"","calendar-height":300,"event-height":5}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }